






















import _ from "underscore";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import ServiceSummaryStatus from "@/components/service/ServiceSummaryStatus.vue";
import {
  SERVICE_MENU_STATUS_SUMMARY_TEXT,
  SERVICE_MENU_STATUS_SUMMARY_TEXT_OTHER,
  ServiceMenuStatus,
  ServiceMenuType,
} from "@/consts/const";
import { ServiceInterface } from "@/interfaces/service.interface";
import { ServiceMenuInterface } from "@/interfaces/service-menu.interface";
import { StatusUtil } from "@/utils/status-util";

@Component({
  components: { ServiceSummaryStatus },
})
export default class ServiceSummaryItem extends Vue {
  @Prop({ required: true }) private service!: ServiceInterface;
  private serviceName = "";
  private statusList: ServiceMenuStatus[] = [ServiceMenuStatus.Ok];
  private statusMessage = "message.ServiceSummaryItem.initial_status_message";
  private otherInfos: ServiceMenuStatus[] = [];
  private otherInfosMessage = "message.ServiceSummaryItem.initial_status_message";
  private hasTwoIcons = false;
  private viewOtherInfo = false;

  mounted(): void {
    this.setUp();
  }

  @Watch("service")
  private onWatchService(): void {
    this.setUp();
  }

  private get hasWave(): boolean {
    return this.$device.isSp();
  }

  private setUp(): void {
    this.serviceName = this.service.name;
    this.statusList = this.getStatusList(this.service);
    this.statusMessage = this.getStatusMessage(this.statusList);
    this.otherInfos = this.getOtherInfos(this.service);
    
    /*** 2025.03.04 [ADD] EVERFOR (START)  ***/
    //▽障害/一部障害の場合は"障害情報あり"を表示するようにする
    /* ★★3/14リリース分からは"障害情報あり"表示を除外
    if ( this.statusList.indexOf( 1 ) > -1 || this.statusList.indexOf( 2 ) > -1 ) {
      //◇お知らせありが含まれる場合を想定して情報をクリアした後に、"障害情報あり"をセット
      this.otherInfos.length = 0;
      this.otherInfos.push( ServiceMenuStatus.Failure )
    }
    */

    //▽お知らせがある場合は画面上に表示する
    if ( this.otherInfos.length > 0 ) {
      this.viewOtherInfo = true;
    }
    /*** 2025.03.04 [ADD] EVERFOR ( END )  ***/

    this.otherInfosMessage = this.getOtherInfoMessage(this.otherInfos);
    this.hasTwoIcons =
      this.statusList.length === 2 || this.otherInfos.length === 2;
  }

  private getStatusList(service: ServiceInterface): ServiceMenuStatus[] {
    const items: number[] = _.uniq(
      _.flatten(
        service.serviceMenus.map((menu: ServiceMenuInterface) => {
          if (menu.type === ServiceMenuType.Event) {
            return StatusUtil.getEventStatusList(menu.data);
          }

          return [StatusUtil.getStatus(menu.data)];
        })
      )
    ).filter((status: ServiceMenuStatus) => status !== ServiceMenuStatus.Ok);

    if (items.length === 0) {
      return [ServiceMenuStatus.Ok];
    }

    if (items.length === 2) {
      return [ServiceMenuStatus.Warning, ServiceMenuStatus.Error];
    }

    return items;
  }

  private getStatusMessage(statusList: ServiceMenuStatus[]): string {
    if (statusList.length === 2) {
      return SERVICE_MENU_STATUS_SUMMARY_TEXT_OTHER.WARNING_ERROR;
    }

    if (statusList.length === 0) {
      return SERVICE_MENU_STATUS_SUMMARY_TEXT[ServiceMenuStatus.Ok];
    }

    return SERVICE_MENU_STATUS_SUMMARY_TEXT[statusList[0]];
  }

  private getOtherInfos(service: ServiceInterface): ServiceMenuStatus[] {
    const items: ServiceMenuStatus[] = _.uniq(
      _.flatten(
        service.serviceMenus.map((menu: ServiceMenuInterface) =>
          _.keys(menu.data).map((i) => Number(i))
        )
      )
    );

    const info: ServiceMenuStatus[] = [];

    if (items.includes(ServiceMenuStatus.Notification)) {
      info.push(ServiceMenuStatus.Notification);
    }

    return info;
  }

  private getOtherInfoMessage(otherInfos: ServiceMenuStatus[]): string {
    if (otherInfos.length === 2) {
      return SERVICE_MENU_STATUS_SUMMARY_TEXT_OTHER.ALL_OTHERS;
    } else if (otherInfos.length === 0) {
      return SERVICE_MENU_STATUS_SUMMARY_TEXT_OTHER.NO_OTHERS;
    } else if (otherInfos.includes(ServiceMenuStatus.Notification)) {
      return SERVICE_MENU_STATUS_SUMMARY_TEXT[ServiceMenuStatus.Notification];
    //★障害情報あり表示用
/*     } else if (otherInfos.includes(ServiceMenuStatus.Failure)) {
      return SERVICE_MENU_STATUS_SUMMARY_TEXT[ServiceMenuStatus.Failure]; */
    } else {
      return "ー";
    }
  }

  private onClick(): void {
    this.$emit("click", this.service);
  }
}
